import React from 'react';

function Item(props) {
  return (
      <span className={"n"}>{props.charItem}</span>
  );
}
export default Item;